import Vuex from 'vuex'
import Vue from 'vue'
import { constantRoutes } from '@/router'

Vue.use(Vuex)

const getLocalUserInfo = () => {
  try {
    return JSON.stringify(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : null
  } catch (e) {
    return null
  }
}
const initialUser = getLocalUserInfo()

const getLocalAccessToken = () => {
  try {
    return JSON.stringify(localStorage.getItem('accessToken')) ? JSON.parse(localStorage.getItem('accessToken')) : null
  } catch (e) {
    return null
  }
}
const initialAccessToken = getLocalAccessToken()

const store = new Vuex.Store({
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    roles: state => state.roles,
    routes: state => state.routes,
    addRoutes: state => state.addRoutes,
    socketStatus: state => state.socketStatus
  },
  state: {
    token: initialAccessToken ? initialAccessToken.accessToken : null,
    userInfo: initialUser,
    roles: initialUser ? (initialUser.roles || []) : [], // 🌟 刷新页面时自动从本地恢复角色
    routes: [],
    addRoutes: [],
    socketStatus: 'Offline'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('accessToken', JSON.stringify({ accessToken: token }))
    },
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    UPDATE_SOCKET_STATUS(state, status) {
      state.socketStatus = status
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      state.roles = userInfo.roles || []
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    USER_LOGOUT(state) {
      state.token = null
      state.userInfo = null
      state.roles = []
      localStorage.removeItem('accessToken')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    generateRoutes({ commit }, roles) {
      return new Promise(resolve => {
        const accessedRoutes = []
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      })
    },
    // 🌟 修复：如果 state 里没角色，尝试从 localStorage 获取
    getUserRoles({ commit, state }) {
      return new Promise((resolve) => {
        if (state.roles && state.roles.length > 0) {
          resolve(state.roles)
        } else {
          const localUser = getLocalUserInfo()
          const roles = localUser ? (localUser.roles || []) : []
          commit('SET_ROLES', roles)
          resolve(roles)
        }
      })
    }
  }
})

export default store
